export class CoreConstants {
  // default headers set for Http Calls
  public static readonly HTTP_HEADERS = {
    'Content-Type': 'application/json',
    Accept: 'application/json'
  };

  public static readonly MODAL_WINDOW_TIMEOUT = 250;

}
